var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarterPricingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2422 6.16406C14.9453 6.16406 15.4661 6.46354 15.8047 7.0625C16.1432 7.66146 16.1432 8.26042 15.8047 8.85938L8.61719 19.6406C8.30469 20.2135 7.8099 20.5 7.13281 20.5C6.53385 20.5 6.05208 20.2656 5.6875 19.7969C5.34896 19.3542 5.24479 18.8594 5.375 18.3125L6.74219 12.375H2.91406C2.34115 12.375 1.8724 12.1667 1.50781 11.75C1.14323 11.3073 0.986979 10.7995 1.03906 10.2266L3.10938 1.94531C3.16146 1.55469 3.35677 1.21615 3.69531 0.929688C4.03385 0.643229 4.42448 0.5 4.86719 0.5H9.94531C10.5443 0.5 11.013 0.734375 11.3516 1.20312C11.7161 1.67188 11.8203 2.19271 11.6641 2.76562L10.5703 6.16406H14.2422ZM7.28906 18.3516L14.0859 8.03906H7.99219L9.82812 2.33594L4.86719 2.375L2.91406 10.5H9.08594L7.28906 18.3516Z",
    fill: "#B8CC3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarterPricingIcon);
export default __webpack_public_path__ + "static/media/StarterPricingIcon.b7fdfc4acb2cc27925aaff02ec94966e.svg";
export { ForwardRef as ReactComponent };